import React from 'react'
import Container from '../Container/Index'
import Title from '../Title/Index'
import Featureslider from '../Gallery/Featureslider'
import ImageTag from '../ImageTag/Index'

const Overview = ({Data, infrastructure, Data2, serviceDetail, serviceContent, customClass, _class}) => {
  return (
    <Container _parentClass="Overview" containerClass={'float-end'} sectionID={'overview'}>
          <div className={`col-lg-7 col-md-10 col-sm-12 col-12 m-auto position-relative ${customClass}`}>
            <Title firstHeading={Data.title} secondHeading={Data.heading} subTitle={Data.descp} headingOne={true} _class={_class}/>
           </div>
        
 {Data.availableSize && 
  <div className="col-lg-8 col-12 m-auto position-relative capabilities">    
    {Data.availableSize?.length > 0 && (
      <div className='row align-items-end'>
      {Data.availableSize.map((items, index) => (
        <div 
          className='col-lg-4 col-12' 
          key={index}
          data-aos="fade-up"
          data-aos-offset="100"
          data-aos-duration="500"
          data-aos-once="true"
          data-aos-easing="ease-in-sine"
        >
          <div className='cardStnComponent  h-auto p-0 overflow-hidden flex-center spacing-150'>
            <ImageTag ImagePath={items.imagePath} ImageClass={'m-0'}/>
            <div className='col-lg-12 col-12 flaot-start bottleContent text-center'>
            <h2 className='productTitle text-uppercase h-auto mb-2'>{items.title}</h2>
          {items.description.map((list, index) => (
             <p dangerouslySetInnerHTML={{__html: list}} key={index} className='col-12 float-start m-0'/>
           ))}
            </div>
          </div>
        </div>
      ))}
      </div>
    )}
    {Data.capabilities?.length > 0 && (
      <div className='row mt-3'>
      {Data.capabilities.map((items, index) => (
        <div 
          className='col-lg-6 col-12' 
          key={index}
          data-aos="fade-up"
          data-aos-offset="100"
          data-aos-duration="500"
          data-aos-once="true"
          data-aos-easing="ease-in-sine"
        >
          <div className='cardStnComponent bottleDesign overflow-hidden flex-center spacing-150'>
            <div className='col-lg-12 col-12 flaot-start '>
            <h2 className='productTitle text-uppercase h-auto mb-2'>{items.title}</h2>
          <ul className='gap-0'>
          {items.description.map((list, index) => (
             <li dangerouslySetInnerHTML={{__html: list}} key={index} className='col-12 float-start'/>
           ))}
          </ul>
            </div>
          </div>
        </div>
      ))}
      
    </div>
    )}
  </div>
  }
      
          {serviceDetail && 
            <>
            <Container>
              <div className='col-lg-8 col-sm-12 col-12 m-auto' >
              {Data.imagePath ? (
            <>
              <ImageTag ImagePath={Data.imagePath} ImageAlt={Data.heading} ImageWidth={1000} ImageHeight={500}/></> ) : (
             <> <div className='col-12 float-start Noimage flex-center h-100'>
             <ImageTag ImageAlt={'No Image Found'} /> 
           </div></>
             
            )}
         {serviceContent?.length > 0 ? (
  serviceContent.map((items, index) => (
    <div className='col-12 float-start serviceContent py-3 p-lg-4 pb-lg-0 text-lg-start text-center' key={index}  data-aos="fade-up"
    data-aos-offset="100"
    data-aos-duration="500"
    data-aos-once="true"
    data-aos-easing="ease-in-sine">
      <h2>{items.heading}</h2>
      <ul>
      {items.listPoint.map((list, i) => {
  const formattedList = list.replace(/^(\w+)/, '<strong>$1</strong>');
  return (
    <li dangerouslySetInnerHTML={{ __html: formattedList }} key={i} />
  );
})}
      </ul>
    </div>
  ))
) : null}

              </div>
            </Container>
            {Data?.featureData?.length > 0 ? ( <Featureslider Data={Data2} slidesPerView={2.8} secondSlider={'hoverEffect'} spaceBetween={50} ImageHeight={'700'} ImageWidth={'600'}/>  ) : (null)}
            </>
          }
          {infrastructure && 
              <>              
              {/* <ProListing Data={Data2} servicePage={true} listingClass={listingClass}/> */}
              {/* <Featureslider Data={Data2} slidesPerView={2.8} secondSlider={'hoverEffect'} spaceBetween={100} ImageHeight={'400'} ImageWidth={'600'}/> */}
              </>
          }
        </Container>
  )
}

export default Overview